import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Twitter Speed Thread Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form
      experiencePlatform={'twitter'}
      experienceType={'twitter_speed_thread'}
    />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/twitter_speed_thread/create/index.js